import React from 'react'
import "./footer.css"

function Footer() {
  return (
    <div className='footer-container'>
        <div className='footer-parent'>
            <img src={require ("../../../assets/Home/shape-bg.png")} alt = "shape bg" />


        </div>

    </div>
  )
}

export default Footer